module.exports = __webpack_public_path__ + "static/article80-dc60bcab5c958ace51df836b46265883.pdf";